module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0027.jpg?v=5a266a55";